var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.74653 8.90057L12.0444 1.60254L14.398 3.95615L7.10013 11.2542L4.74653 8.90057Z",
    fill: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 12.4447L6.15653 11.7243L4.27599 9.84375L3.55556 12.4447Z",
    fill: "#0E4C54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0472 0.365341C14.5589 -0.12178 13.7684 -0.12178 13.2801 0.365341L12.75 0.895415L15.1036 3.24902L15.6337 2.71895C16.121 2.23065 16.121 1.44013 15.6337 0.951839L15.0472 0.365341Z",
    fill: "#0E4C54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.66667C0 1.19391 1.19391 0 2.66667 0H8C8.49092 0 8.88889 0.397969 8.88889 0.888889V0.888889C8.88889 1.37981 8.49092 1.77778 8 1.77778H2.66667C2.17575 1.77778 1.77778 2.17575 1.77778 2.66667V13.3333C1.77778 13.8243 2.17575 14.2222 2.66667 14.2222H13.3333C13.8243 14.2222 14.2222 13.8243 14.2222 13.3333V8C14.2222 7.50908 14.6202 7.11111 15.1111 7.11111V7.11111C15.602 7.11111 16 7.50908 16 8V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667Z",
    fill: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconTable);
export default __webpack_public_path__ + "static/media/edit-icon-table.4314a32ec6d3b273f902164e9fd56b94.svg";
export { ForwardRef as ReactComponent };